// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2xs_c","dragIcon":"SortableItem_dragIcon__QWsGq","disabled":"SortableItem_disabled__1aDdQ"};